module.exports = __webpack_public_path__ + "static/media/bnr_sakura6d3edd89ff7395e91a951e89768cfc0b.webp";